import React from 'react';

const CheckedLabel = () => {
  return (
    <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      {/* <!-- Generator: Sketch 57.1 (83088) - https://sketch.com --> */}
      <title>Checked</title>
      <desc>Created with Sketch.</desc>
      <g id="Revised-Lead-journey" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Fibre/Desktop/planselectio-Copy-6" transform="translate(-488.000000, -519.000000)">
          <g id="Filters/Dark-filter/Desktop/Closed" transform="translate(1.000000, 371.000000)">
            <g id="SECTION-4" transform="translate(487.000000, 100.000000)">
              <g id="Label-1" transform="translate(0.000000, 48.000000)">
                <g id="Group-34">
                  <g id="🧩-Components/Forms:-Selection/Checkbox/White/Unchecked">
                    <g id="🧩-Components/Forms:-Selection/Checkbox/Colour/Checked-|-Pre-login-|-Black">
                      <rect id="Rectangle-5" fill="#333333" fillRule="evenodd" x="0" y="0" width="20" height="20" rx="2"></rect>
                      <polyline id="Checkbox-tick" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" points="15 6.5 8.15789474 13.5 5 10.2692308"></polyline>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default CheckedLabel;